<template>
  <div class="playerDistributePie" ref="playerDistributePie">
    <div class="themeData">
      <div
        class="echart_dom"
        ref="echartDom_home"
        :style="{ height: `${pHeight}px` }"
      ></div>
    </div>
  </div>
</template>

<script>
// 运动员分布 主题
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'playerDistributePie',
  mixins: [canvasToImage_base64_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        title: '',
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      echartsArr: [],
      pHeight: 0,
    }
  },
  watch: {
    datas(val) {
      setTimeout(() => {
        this.initChart(this.$refs.echartDom_home, this.isAutoExportPng)
      }, 10)
    },
  },
  created() {
    // this.pieColor = [
    //   'rgba(255, 183, 101, 1)',
    //   'rgba(53, 192, 213, 1)',
    //   'rgba(170, 57, 230, 1)',
    //   'rgba(201, 86, 138, 1)',
    //   'rgba(33, 167, 190, 1)',
    //   'rgba(201, 86, 138, 1)',
    // ]
    console.debug(this.datas)
  },
  mounted() {
    this.$nextTick(() => {
      this.initDomWH()
      setTimeout(() => {
        this.initChart(this.$refs.echartDom_home, this.isAutoExportPng)
      }, 10)
    })
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myEChart) {
      this.myEChart.dispose() //销毁echarts实例，防止内侧泄露
    }
    this.echartsArr = []
  },
  methods: {
    initDomWH() {
      const echartsBoxDom = this.$refs.playerDistributePie
      console.debug('playerDistributePie:', echartsBoxDom.clientWidth)
      this.pWidth = echartsBoxDom.clientWidth

      this.pHeight = echartsBoxDom.clientHeight
      console.debug('this.pWidth:', this.pWidth, this.pHeight)
    },
    initChart(echartRef, isAutoExportPng) {
      const name = 'playerDistributePie'
      let result = this.echartsArr.some((val) => {
        if (val.name === name) {
          return true
        }
      })

      console.debug('result', result)

      if (!result) {
        let Echart = this.$echarts.init(echartRef)
        this.echartsArr.push({
          name: name,
          refs: echartRef,
          echarts: Echart,
        })
        setTimeout(() => {
          Echart.resize()
        }, 0)
      }
      // const objectInfo = this.datas.objectInfo
      // const keyArr = this.datas.statisticsModels
      const dataList = this.datas.data.dataList
      // const maxList = this.datas.data.maxList

      console.debug('radarNameArr:', dataList)

      const seriesData = dataList.map((item, index) => {
        let value = item.number ? item.number : 0
        return {
          value,
          name: item.showTitle ? item.showTitle : '',
        }
      })

      let vw = (window.innerWidth || window.screen.availWidth || 1440) / 100

      let options = {
        // title: {
        //   show: false,
        //   text: '阅读书籍分布',
        //   left: 'center',
        //   textStyle: {
        //     color: '#999',
        //     fontWeight: 'normal',
        //     fontSize: 14,
        //   },
        // },
        // color: this.pieColor,
        series: {
          type: 'pie',
          radius: [20, 80],
          top: 0,
          height: `${this.pHeight}px`,
          left: 'center',
          width: '100%',
          label: {
            alignTo: 'edge',
            formatter: (params) => {
              // console.debug(params)
              return `{name|${params.value} ${params.name}}\n{time|${params.percent}%}`
            },
            minMargin: Math.floor(0.347 * vw),
            edgeDistance: Math.floor(0.694 * vw),
            lineHeight: Math.floor(0.972 * vw),
            rich: {
              time: {
                fontSize: Math.floor(0.833 * vw),
                color: 'rgba(255, 255, 255, 1)',
                backgroundColor: 'rgba(148, 190, 33, 1)',
                borderRadius: Math.floor(0.437 * vw),
                padding: [0, Math.floor(0.287 * vw)],
              },
            },
          },
          labelLine: {
            length: Math.floor(1.388 * vw),
            length2: 0,
            maxSurfaceAngle: 80,
          },
          labelLayout: function (params) {
            const isLeft = params.labelRect.x < this.pWidth / 2
            const points = params.labelLinePoints
            // Update the end point.
            points[2][0] = isLeft
              ? params.labelRect.x
              : params.labelRect.x + params.labelRect.width
            return {
              labelLinePoints: points,
            }
          },
          data: seriesData,
        },
      }
      this.echartsArr.forEach((val, index) => {
        if (val.name === name) {
          console.debug('val.name:', val.name, 'name', name)
          val.echarts.setOption(options)
        }
      })
      //   console.debug('emitEventName:', isAutoExportPng)
      //   if (isAutoExportPng) {
      //     setTimeout(() => {
      //       this.upLoad(echartRef, true, 'uploadData')
      //     }, 500)
      //   }
    },
  },
}
</script>

<style lang="scss" scoped>
.playerDistributePie {
  position: relative;
  width: 100%;
  height: 19.02vw;
  padding: 0 3%;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  .themeData {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .echart_dom {
      width: 85%;
    }
  }
}
.mixtmt_ipad .playerDistributePie {
  padding: 0 2%;
  .themeData {
    .echart_dom {
      width: 85%;
    }
  }
}
</style>
